export enum EImportDestination {
  CONTRACT = "rubk.faturamento",
  ADDITIVES = "rubk.aditivo",
  MEASUREMENT = "rubk.medicao",
}
